module.exports = __webpack_public_path__ + "img/vonestis_spa_03.7d4b61b3.jpg";